module.exports = __webpack_public_path__ + "static/media/seriousBleedingContinues.fa7fbb31.mp3";